import { ISingleOperationPayload, IOperationHandlerThunkAction } from '@ms/items-view/lib/private/addons/registerOperationHandler';
import {
  spSearchItemSetKeyFacet,
  spFolderItemSetKeyFacet,
  spItemKeyFacet,
  spPinnedItemSetKeyFacet,
  spViewKeyFacet,
  spNeedsAttentionItemKeyFacet,
  spListKeyFacet,
  spGridInitInfoKeyFacet,
  spPageContextKeyFacet
} from '../dataSource/Keys';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItemsOperation';
import { PerfMark, itemsViewPerfMarkers } from '../utilities/logging/performance/PerfMarkers';
import { IItemCacheDispatch, IItemCacheThunkAction } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { getContentTypes, constructGetItemSetContext } from '../dataSource/getServerDataContext';
import { ISPListItemRetrieverResponse, ISPGetItemResponse } from '@ms/odsp-datasources/lib/SPListItemRetriever';
import { getServerDataWithPrefetch } from '../dataSource/getServerData';
import * as RUMOneHelper from '../utilities/logging/performance/RUMOneHelper';
import { GetDataError } from '../dataSource/getData';
import { ItemResolver } from '@ms/items-view/lib/private/models/items/ItemResolver';
import { readItem } from '@ms/items-view/lib/private/operations/readItem';
import {
  largeFolderFacet,
  folderPathFacet,
  contentTypeKeysFacet,
  permissionsFacet,
  documentSetFacet,
  progIdFacet,
  isRootFolderFacet,
  listItemIdFacet,
  uniqueIdFacet,
  listSchemaFacet,
  spFilterableSetFacet,
  viewFormatterFacet,
  getItemResponseFacet,
  getItemResponseJsonStringFacet,
  canModifySchemaFacet,
  columnTotalsFacet,
  needsAttentionItemFacet,
  defaultViewFacet,
  gridInitInfoFacet,
  onProcessListItemResponseConfigurationFacet,
  spErrorDataFacet
} from '../dataSource/Facets';
import { logEngagement } from '@ms/items-view/lib/private/operations/logEngagement';
import { ItemOperationError } from '@ms/items-view/lib/private/store/actions/implementOperation';
import { ISpPageContext } from '@ms/odsp-datasources/lib/interfaces/ISpPageContext';
import {
  IListViewAdapter,
  IListViewSpfxHostApplication,
  ISpfxAdapter
} from '@ms/odsp-datasources/lib/interfaces/clientSideExtensions/ISpfxAdapter';
import { getLoadSpfxHostApplicationFunction, getLoadSpfxAdapterFunction } from '../utilities/list/ListExtensionHelper';
import { readItems } from '@ms/items-view/lib/private/operations/readItems';
import { processResponse } from '../dataSource/processResponse';
import { getFolderName } from '../dataSource/operations/getFolderName';
import { getParentItemKey, getAllAncestorItems } from '../dataSource/operations/getAllAncestorItems';
import SimpleUri from '@ms/items-view-utilities/lib/uri/SimpleUri';
import { normalizeLower } from '@ms/items-view-utilities/lib/guid/Guid';
import {
  getDriveItemKey,
  getEndpointVersionKeyAliases
} from '@ms/items-view-addon-graph/lib/utilities/getDriveItemKey';
import {
  preferredKeyFacetFacet
} from '@ms/items-view/lib/private/facets/OperationFacets';
import { driveItemKeyFacet } from '@ms/items-view-addon-graph/lib/models/keys/DriveItemKeyFacet';
import {
  analyticsItemFacet,
  followedItemFacet,
  activityItemFacet,
  parentFolderItemFacet,
  folderFacet,
  displayNameFacet,
  fileNameFacet,
  fileSizeFacet,
  vroomUrlFacet,
  openUrlFacet
} from '@ms/items-view/lib/private/facets/ItemFacets';
import { driveAnalyticsItemKeyFacet } from '@ms/items-view-addon-graph/lib/models/keys/DriveAnalyticsItemKeyFacet';
import { driveFollowedItemKeyFacet } from '@ms/items-view-addon-graph/lib/models/keys/DriveFollowedItemKeyFacet';
import { driveActivityItemKeyFacet } from '@ms/items-view-addon-graph/lib/models/keys/DriveActivityItemKeyFacet';
import {
  defaultChildItemSetFacet,
  childItemsFacet,
  schemaFacet,
  parentItemFacet,
  filterOptionSetsFacet
} from '@ms/items-view/lib/private/facets/SetFacets';
import { getInvalidationFacet, invalidateItems } from '@ms/items-view/lib/private/operations/invalidateItems';
import { resolveItems } from '@ms/items-view/lib/private/operations/resolveItems';
import { IFilter } from '@ms/odsp-datasources/lib/interfaces/view/IViewArrangeInfo';
import ListFilterUtilities from '@ms/odsp-datasources/lib/utilities/list/ListFilterUtilities';
import { IViewFormatterFacet, getViewFormatterFacetObj, hasColumnFormatters } from '../models/viewFormatter';
import { pack, IFaceted, unpack } from '@ms/items-view/lib/private/models/Facet';
import { MirrorPatch, ReplacePatch } from '@ms/items-view/lib/private/utilities/Graft';
import { buildListFacets } from '../utilities/list/ListFacetBuilder';
import { listViewAdapterFacet } from '../models/facets/ClientSideExtensionFacets';
import { updatePageContext } from '../dataSource/operations/updatePageContext';
import { getItems } from '@ms/items-view/lib/private/operations/getItems';
import { customFormatterFeatureKeyFacet, customFormatterFeatureFacet } from '../models/facets/CustomFormatterFacets';
import { readConfiguration } from '@ms/items-view/lib/private/operations/configuration/readConfiguration';
import { malwareErrorFacet, accessDeniedErrorFacet, itemNotFoundErrorFacet } from '@ms/items-view/lib/private/facets/ErrorFacets';
import { getFilteredItemSetKey } from '../models/keys/getFilteredItemSetKey';
import { clearCacheIfNotOffline } from '@ms/items-view/lib/private/operations/offlineCache';
import { doExtFiltersHaveMediaTypesOnly, getIItemTypeFilter } from '@ms/odsp-graph/lib/utilities/media/MediaUtils';
import { ItemTypeFilter } from '@ms/odsp-graph/lib/models/item/IItemTypeFilter';
import { mediaGroupFacet } from '@ms/items-view/lib/private/facets/GroupFacets';
import { FileTypeIconMap } from '@uifabric/file-type-icons/lib/FileTypeIconMap';
import { updateItems } from '@ms/items-view/lib/private/store/reducers/itemMapReducer';
import { hasPageLoadedFacet } from '@ms/items-view/lib/private/facets/LoggerFacets';
import { pageLoadItemKey, getHasPageLoaded } from '@ms/items-view/lib/private/operations/pageLoad';
import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';

interface IGetFolderItemSetOption {
  skipCache?: boolean;
  skipPrefetch?: boolean;
}

export function getFolderItemSetForItemSetKey(
  itemSetKey: typeof spFolderItemSetKeyFacet.type | typeof spSearchItemSetKeyFacet.type
): (
    payload: ISingleOperationPayload<typeof spSearchItemSetKeyFacet.type, typeof getItemsOperation.type>,
    options?: IGetFolderItemSetOption
  ) => IOperationHandlerThunkAction {
  function getItemSet(
    payload: ISingleOperationPayload<typeof spSearchItemSetKeyFacet.type, typeof getItemsOperation.type>,
    options: IGetFolderItemSetOption = {}
  ): IOperationHandlerThunkAction {
    if (!PerfMark.getMarkerTime(itemsViewPerfMarkers.dataFetch.start)) {
      PerfMark.mark(itemsViewPerfMarkers.dataFetch.start);
    }

    let serializedParentItemKey = spItemKeyFacet.serialize(itemSetKey);

    return async (dispatch: IItemCacheDispatch) => {
      // Get the previously-resolved data for the item set to determine whether this
      // `getItems` operation also needs to refresh stale data from a request cache.
      const currentGetItemResponse = dispatch(readItems((itemCache: IItemCache) => {
        return itemCache.demandItemFacet(getItemResponseFacet, payload.itemKey) as ISPListItemRetrieverResponse | undefined;
      }));

      const isFromServiceWorkerCache = currentGetItemResponse && currentGetItemResponse.isFromServiceWorkerCache;
      const isFromCustomCache = currentGetItemResponse && currentGetItemResponse.isFromCustomCache;

      const {
        skipCache = !!isFromServiceWorkerCache || !!isFromCustomCache,
        skipPrefetch = !!isFromCustomCache
      } = options;

      const contentTypes = dispatch(getContentTypes({ itemSetKey }));
      const getItemContext = await dispatch(constructGetItemSetContext({
        itemSetKey,
        contentTypes,
        skipCache,
        qosName: 'getSPFolderItemSet'
      }));

      let serverData: ISPListItemRetrieverResponse;

      try {
        serverData = await dispatch(getServerDataWithPrefetch(
          payload.itemKey,
          getItemContext,
          async (serverDataFromFallBack: ISPListItemRetrieverResponse) => {
            await dispatch(buildSPItemSet(
              serverDataFromFallBack,
              itemSetKey,
              payload.itemKey,
              serializedParentItemKey,
              getItemContext.currentPageContext,
              getItemContext.postDataContext && getItemContext.postDataContext.needClientSideComponentManifest));
          },
          skipPrefetch));
        if (serverData.isFromServiceWorkerCache) {
          dispatch(RUMOneHelper.addEUPLBreakdown('isPrefetchRenderListFromCache', { data: 1, needFlatten: true }));
        }
      } catch (error) {
        if (error instanceof GetDataError && error.errorData.code === '-2147024860, Microsoft.SharePoint.SPQueryThrottledException') {
          const itemResolver = new ItemResolver();

          const isLargeFolderFacet = dispatch(readItem({
            isLarge: largeFolderFacet
          }, serializedParentItemKey));

          const isLargeFolder = isLargeFolderFacet && isLargeFolderFacet.isLarge;
          if (isLargeFolder) {
            // if we already have set largefolder flag, re-throw.
            // log throttling reasons.
            dispatch(logEngagement({
              name: 'listView.Throttled',
              extraData: {
                correlationId: error.correlationId,
                sortField: itemSetKey.sortFieldKey,
                sortOrder: itemSetKey.sortAscending,
                filterField: itemSetKey.filterParams,
                groupByField: itemSetKey.groupByFieldKey,
              },
              isIntentional: false
            }));
            throw error;
          }
          // set largeFolder facet
          itemResolver.resolveItems({
            items: {
              [serializedParentItemKey]: {
                ...largeFolderFacet.pack(true)
              }
            }
          });
          dispatch(itemResolver.execute());
          // refetch the itemset data with the new grouping flag.
          await dispatch(getItemSet(payload));
          return;
        } else {
          throw dispatch(processError({
            ...payload,
            error
          }));
        }
      }

      await dispatch(buildSPItemSet(
        serverData,
        itemSetKey,
        payload.itemKey,
        serializedParentItemKey,
        getItemContext.currentPageContext));

      if (serverData.isFromServiceWorkerCache || serverData.isFromCustomCache) {
        const hasPageLoaded = dispatch(getHasPageLoaded());
        const pinnedItemSetKey = spPinnedItemSetKeyFacet.serialize({
          parentItemKey: itemSetKey,
          viewKey: itemSetKey.viewKey || {viewId: normalizeLower(serverData.view, false/*strip brackets*/)}
        });

        if (hasPageLoaded) {
          // If the page has already loaded, immediately invalidate the content so it can be refreshed and bypass
          // the cache.
          dispatch(invalidateItems({
            items: {
              [payload.itemKey]: [childItemsFacet],
              [pinnedItemSetKey]: [childItemsFacet]
            }
          }));
        } else {
          // Schedule a trigger so when the page finally loads, the cached content is invalidated.
          dispatch(resolveItems({
            items: {
              [pageLoadItemKey]: {
                ...getInvalidationFacet()
                  .forFacet(hasPageLoadedFacet).thenInvalidate(payload.itemKey, childItemsFacet)
                  .forFacet(hasPageLoadedFacet).thenInvalidate(pinnedItemSetKey, childItemsFacet)
                  .pack()
              }
            }
          }));
        }
      }
    };
  }

  return getItemSet;
}

function buildSPItemSet(
  serverData: ISPGetItemResponse,
  itemSetKey: typeof spFolderItemSetKeyFacet.type,
  serializedItemSetKey: string,
  serializedParentItemKey: string,
  currentPageContext: ISpPageContext | undefined,
  requestSpfxFrameworkInfo?: boolean
): IOperationHandlerThunkAction {
  return async (dispatch: IItemCacheDispatch) => {
    if (!PerfMark.getMarkerTime(itemsViewPerfMarkers.dataFetch.end)) {
      PerfMark.mark(itemsViewPerfMarkers.dataFetch.end);
    }

    // Load client-side listview spfx adapter for extensions
    let listViewAdapter: IListViewAdapter | undefined = undefined;
    if (requestSpfxFrameworkInfo && serverData.SPFrameworkClientInfo || !requestSpfxFrameworkInfo) {
      // If an app provides loadSpfxHostApplication function, use it. Example: odsp-next
      const loadSpfxHostApplication = dispatch(readItems(getLoadSpfxHostApplicationFunction));
      if (loadSpfxHostApplication) {
        const spfxHostApp: IListViewSpfxHostApplication = await loadSpfxHostApplication(serverData.SPFrameworkClientInfo);
        if (spfxHostApp && typeof spfxHostApp.navigateToPreloadedData === 'function' &&
          serverData.SPFrameworkClientInfo && serverData.SPFrameworkClientInfo.PageContextJson) {
          try {
            const spfxPageContextJson = serverData.SPFrameworkClientInfo.PageContextJson;
            const spfxPageContext = JSON.parse(spfxPageContextJson);
            spfxHostApp.navigateToPreloadedData(spfxPageContext);
            const spfxAdapter = spfxHostApp.adapter;
            if (spfxAdapter) {
              listViewAdapter = spfxAdapter.createListViewAdapter();
            }
          } catch (e) {
            console.log('error loading spfx preloaded data with spfxPageContext');
          }
        }
      }

      // Otherwise, try loadSpfxAdapter function. Example: listview-webpart
      if (!listViewAdapter) {
        const loadSpfxAdapter = dispatch(readItems(getLoadSpfxAdapterFunction));
        if (loadSpfxAdapter) {
          const spfxAdapter: ISpfxAdapter = await loadSpfxAdapter(serverData.SPFrameworkClientInfo);
          if (spfxAdapter) {
            if (typeof spfxAdapter.registerManifests === 'function' &&
              serverData.SPFrameworkClientInfo && serverData.SPFrameworkClientInfo.PageContextJson) {
              try {
                const preloadedData = JSON.parse(serverData.SPFrameworkClientInfo.PageContextJson);
                /* tslint:disable:no-string-literal */
                if (preloadedData) {
                  const preloadedManifest = preloadedData['manifests'];
                  if (preloadedManifest) {
                    spfxAdapter.registerManifests(preloadedManifest);
                    listViewAdapter = spfxAdapter.createListViewAdapter();
                  }
                }
                /* tslint:enable:no-string-literal */
              } catch (e) {
                console.log('error parsing pageContextJson for manifests');
              }
            }
          }
        }
      }
    }

    const contentTypes = dispatch(getContentTypes({ itemSetKey }));
    const isItemSetRequest = true;
    const {
      itemResolver,
      childKeys,
      columnKeys,
      filterOptionSets,
      parentFolderPermissons,
      hasTitle,
      pageContext,
      itemSetGetAsItemKey,
      contentTypeKeys,
      folderContentTypeKeys,
      pinnedItemKeys,
      pinnedItemSetKey,
      defaultViewKey,
      canModifySchema,
      hasFieldCustomizer,
      isDocSet,
      isRootFolder,
      spFolderAggregateData,
      progId
    } = dispatch(processResponse({
      serverData,
      itemSetKey,
      currentPageContext,
      contentTypes,
      listViewAdapter,
      isItemSetRequest
    }));

    if (hasFieldCustomizer && listViewAdapter) {
      await listViewAdapter.loadFieldCustomizers();
    }
    // when itemSetGetAsItemKey is not empty, that means we want to use the new item set key
    // This is to handle DefaultDocumentLibrary scenario. We only know the listFullUrl after the first call.
    if (itemSetGetAsItemKey) {
      itemSetKey = itemSetGetAsItemKey;
      serializedParentItemKey = spItemKeyFacet.serialize(itemSetKey);
    }

    const folderName = dispatch(getFolderName({ key: itemSetKey, serverData }));
    const grandParentItemKey = getParentItemKey(itemSetKey);
    const isMediaFilter = (itemSetKey.extFilters) ? doExtFiltersHaveMediaTypesOnly({
      extFilters: getIItemTypeFilter(itemSetKey.extFilters),
      allowedMediaTypes: [ItemTypeFilter.photo, ItemTypeFilter.video],
      fileTypeIconMap: FileTypeIconMap
    }) : false;
    const folderPath = itemSetKey.rootFolder || new SimpleUri(itemSetKey.listFullUrl).path;
    const folderListItemId = serverData.ListData && serverData.ListData.FolderId;
    const folderUniqueId = serverData.ListData && serverData.ListData.CurrentFolderUniqueId ?
      normalizeLower(serverData.ListData.CurrentFolderUniqueId) : undefined;
    const folderSpItemUrl = serverData.ListData && serverData.ListData.CurrentFolderSpItemUrl;
    const driveUrl = serverData.ListSchema && serverData.ListSchema['.driveUrl'];
    const folderDriveItemKey = folderSpItemUrl ?
      getDriveItemKey(folderSpItemUrl) :
      isRootFolder && driveUrl ?
        getDriveItemKey(driveUrl) :
        undefined;

    if (folderDriveItemKey) {
      const folderDriveItemKeyAliases = getEndpointVersionKeyAliases(folderDriveItemKey);

      for (const folderDriveItemKeyAlias of folderDriveItemKeyAliases) {
        itemResolver.mapKeys({
          mappings: {
            [folderDriveItemKeyAlias]: serializedParentItemKey
          }
        });
      }
    }

    itemResolver.resolveItems({
      items: {
        [serializedParentItemKey]: {
          ...spItemKeyFacet.pack({
            webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
            listFullUrl: itemSetKey.listFullUrl,
            rootFolder: itemSetKey.rootFolder
          }),
          ...(isMediaFilter ? {
            ...mediaGroupFacet.pack({}),
          } : {}),
          ...preferredKeyFacetFacet.pack(spItemKeyFacet),
          ...(folderDriveItemKey ? {
            ...driveItemKeyFacet.pack(folderDriveItemKey),
            ...analyticsItemFacet.pack(
              { itemKey: driveAnalyticsItemKeyFacet.serialize({ driveItemKey: folderDriveItemKey }) }
            ),
            ...followedItemFacet.pack(
              { itemKey: driveFollowedItemKeyFacet.serialize({ driveItemKey: folderDriveItemKey }) }
            ),
            ...activityItemFacet.pack(
              { itemKey: driveActivityItemKeyFacet.serialize({ driveItemKey: folderDriveItemKey }) }
            )
          } : {}),
          ...parentFolderItemFacet.pack(grandParentItemKey ? {
            itemKey: spItemKeyFacet.serialize(grandParentItemKey)
          } : undefined),
          ...folderFacet.pack({}),
          ...(folderPath !== undefined ? folderPathFacet.pack(folderPath) : {}),
          ...(folderName ? displayNameFacet.pack(folderName) : {}),
          ...(folderName ? fileNameFacet.pack({ name: folderName, extension: '' }) : {}),
          ...(folderContentTypeKeys && folderContentTypeKeys.length > 0 ? contentTypeKeysFacet.pack(folderContentTypeKeys) : {}),
          ...(parentFolderPermissons ?
            permissionsFacet.pack(parentFolderPermissons) :
            !itemSetKey.rootFolder ? permissionsFacet.pack(undefined) : {}),
          ...defaultChildItemSetFacet.pack({
            itemKey: spFolderItemSetKeyFacet.serialize(itemSetKey)
          }),
          ...getInvalidationFacet()
            .forFacet(defaultChildItemSetFacet).thenInvalidate(serializedItemSetKey, childItemsFacet)
            .pack(),
          ...documentSetFacet.pack(isDocSet ? {} : undefined),
          ...progIdFacet.pack(progId),
          ...isRootFolderFacet.pack(isRootFolder),
          ...fileSizeFacet.pack(undefined),
          ...(isRootFolder ? vroomUrlFacet.pack(undefined) : (
            folderSpItemUrl ? vroomUrlFacet.pack(folderSpItemUrl) : {}
          )),
          ...(folderListItemId ? listItemIdFacet.pack(folderListItemId) : {}),
          ...(folderUniqueId ? uniqueIdFacet.pack(folderUniqueId) : {})
        }
      }
    });

    // if the parent item is a sub-folder, fill in the entire chain up to the root folder
    if (grandParentItemKey) {
      itemResolver.merge(dispatch(getAllAncestorItems({
        parentKey: grandParentItemKey,
        serverData
      })).itemResolver);
    }

    let appliedFilters: { [fieldName: string]: IFilter } | undefined = undefined;
    let filterList: IFilter[] | undefined = undefined;
    if (itemSetKey.filterParams) {
      filterList = ListFilterUtilities.getFilterList(itemSetKey.filterParams, undefined, true, true);
      if (filterList) {
        appliedFilters = {};
        for (const filter of filterList) {
          appliedFilters[filter.fieldName] = filter;
        }
      }
    }

    const serializedPinnedItemSetKey = spPinnedItemSetKeyFacet.serialize(pinnedItemSetKey);
    // Add pinned items data in the item cache.
    if (pinnedItemKeys) {
      itemResolver.resolveItems({
        items: {
          [serializedPinnedItemSetKey]: {
            ...spPinnedItemSetKeyFacet.pack(pinnedItemSetKey),
            ...childItemsFacet.pack({
              itemKeys: pinnedItemKeys
            })
          }
        }
      });
    }

    if (itemSetKey.viewKey) {
      const serializedViewKey = spViewKeyFacet.serialize(itemSetKey.viewKey);
      itemResolver.resolveItems({
        items: {
          [serializedViewKey]: {
            ...schemaFacet.pack({
              columnKeys: columnKeys
            })
          }
        }
      });
    }

    /**
     * Get the view formatter for this view. It can return undefined if there
     * is no view formatter
     */
    let viewFormatterObj: IViewFormatterFacet | undefined = getViewFormatterFacetObj(serverData.ListSchema);

    const needsAttentionItemKey = spNeedsAttentionItemKeyFacet.serialize({
      webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
      listFullUrl: itemSetKey.listFullUrl,
    });

    itemResolver.resolveItems({
      items: {
        [serializedItemSetKey]: {
          ...spFolderItemSetKeyFacet.pack(itemSetKey),
          ...childItemsFacet.pack({
            itemKeys: childKeys
          }),
          ...folderFacet.pack({}),
          ...schemaFacet.pack({
            columnKeys: columnKeys
          }),
          ...listSchemaFacet.pack({
            HasTitle: hasTitle
          }),
          ...parentItemFacet.pack({
            itemKey: serializedParentItemKey
          }),
          ...filterOptionSetsFacet.pack(filterOptionSets),
          ...spFilterableSetFacet.pack({
            getFilteredItemSetKey: getFilteredItemSetKey(itemSetKey),
            ...(appliedFilters ? { appliedFilters: appliedFilters } : {}),
            ...(itemSetKey.filterParams ? { filterParams: itemSetKey.filterParams } : {}),
            ...(filterList ? { filterList: filterList } : {})
          }),
          /// Cache the viewFormatter config data in the item cache.
          /// Should likely do the same
          /// for the column formatter facet as well
          ...viewFormatterFacet.pack(viewFormatterObj),
          ...preferredKeyFacetFacet.pack(spFolderItemSetKeyFacet),
          ...spPinnedItemSetKeyFacet.pack(pinnedItemSetKey),
          ...pack({
            getItemResponse: getItemResponseFacet
          }, {
              getItemResponse: new ReplacePatch(serverData)
            }),
          ...getItemResponseJsonStringFacet.pack(JSON.stringify(serverData)),
          ...canModifySchemaFacet.pack(canModifySchema),
          ...pack({
            totals: columnTotalsFacet
          }, {
              totals: new MirrorPatch(spFolderAggregateData ? spFolderAggregateData : {})
            }),
          ...needsAttentionItemFacet.pack(needsAttentionItemKey),
          ...getInvalidationFacet()
            .forFacet(childItemsFacet).thenInvalidate(clearCacheIfNotOffline)
            .pack()
        }
      }
    });

    // Place listGuid on the item representing the list
    let listKey = spListKeyFacet.serialize({
      webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
      listFullUrl: itemSetKey.listFullUrl
    });

    itemResolver.resolveItems({
      items: {
        [listKey]: {
          ...buildListFacets(serverData, currentPageContext),
          ...(contentTypeKeys && contentTypeKeys.length > 0 ? contentTypeKeysFacet.pack(contentTypeKeys) : {}),
          ...(listViewAdapter ? listViewAdapterFacet.pack(listViewAdapter) : {}),
          ...(defaultViewKey ? defaultViewFacet.pack({ viewKey: defaultViewKey }) : {}),
        }
      }
    });

    if (serverData.GridInitInfo) {
      itemResolver.resolveItems({
        items: {
          [spGridInitInfoKeyFacet.serialize({
            listKey: {
              webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
              listFullUrl: itemSetKey.listFullUrl
            },
            viewKey: itemSetKey.viewKey
          })]: {
            ...gridInitInfoFacet.pack(serverData.GridInitInfo)
          }
        }
      });
    }

    if (pageContext) {
      const pageContextKey = spPageContextKeyFacet.serialize({
        webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
        listFullUrl: itemSetKey.listFullUrl
      });

      dispatch(updatePageContext(
        {
          itemKey: pageContextKey,
          options: {
            pageContext: pageContext
          }
        }
      ));
    }

    // if we do have a view formatter or column formatters
    // wait for the custom formatter
    // module to load before we proceed to resolveItems, so that
    // we render only after the custom formatter module has been resolved.
    if (viewFormatterObj || hasColumnFormatters(serverData.ListSchema)) {
      // Use 'getItems' to avoid putting 'demandItems' into PLT.
      // Normally, 'demandItems' would be used here because it is the preferred way to load item facets
      // on-demand, as it properly debounces aggregate requests. Do not replicate this pattern!
      await dispatch(getItems({
        items: {
          [customFormatterFeatureKeyFacet.serialize({})]: {
            demands: {
              ...pack({}, {}),
              [customFormatterFeatureFacet.id]: true
            }
          }
        }
      }));
    }

    const {
      onProcessListItemResponseConfiguration
    } = dispatch(readConfiguration({
      onProcessListItemResponseConfiguration: onProcessListItemResponseConfigurationFacet
    }));

    if (onProcessListItemResponseConfiguration) {
      dispatch(onProcessListItemResponseConfiguration({
        itemSetKey: serializedItemSetKey,
        serverData: serverData,
        isItemSetRequest: isItemSetRequest
      }));
    }

    dispatch(itemResolver.execute());
  };
}

interface IProcessErrorPayload extends ISingleOperationPayload<typeof spFolderItemSetKeyFacet.type, typeof getItemsOperation.type> {
  error: Error;
}

function processError(payload: IProcessErrorPayload): IItemCacheThunkAction<Error> {
  const {
    error
  } = payload;

  return (dispatch: IItemCacheDispatch) => {
    const facets = getErrorFacets(error);

    const {
      itemNotFoundError,
      accessDeniedError
    } = unpack({
      itemNotFoundError: itemNotFoundErrorFacet,
      accessDeniedError: accessDeniedErrorFacet
    }, facets);

    if (itemNotFoundError || accessDeniedError) {
      dispatch(updateItems({
        items: {
          [payload.itemKey]: {
            ...childItemsFacet.pack(undefined),
            ...schemaFacet.pack(undefined)
          }
        }
      }));
    }

    return new ItemOperationError({
      facets,
      innerError: error
    });
  };
}

function getErrorFacets(error: Error): IFaceted {
  let facets = pack({}, {});

  if (error instanceof GetDataError) {
    const errorData = error.errorData;

    if (errorData.infected) {
      facets = {
        ...facets,
        ...malwareErrorFacet.pack({})
      };
    }

    const detailedCode = (error.errorData.code || '').split(',')[1];

    switch (detailedCode) {
      case 'policy_enforced':
        facets = {
          ...facets,
          ...accessDeniedErrorFacet.pack({})
        };
        break;
    }

    switch (error.errorData.status) {
      case 404:
        facets = {
          ...facets,
          ...itemNotFoundErrorFacet.pack({})
        };
        break;
      case 401:
        facets = {
          ...facets,
          ...accessDeniedErrorFacet.pack({})
        };
        break;
    }

    if (error.errorData.redirectUrl) {
      facets = {
        ...facets,
        ...openUrlFacet.pack(error.errorData.redirectUrl)
      };
    }

    facets = {
      ...facets,
      ...spErrorDataFacet.pack(errorData)
    };
  }

  return facets;
}
